<template>
  <v-list-item two-line>
      <v-list-item-avatar size="70">
        <v-img
          v-if="thumb"
          :src="thumb"
          :lazy-src="thumb"
          aspect-ratio="1"
        ></v-img>
        <v-img
          v-else
          src="@/assets/img/avatar_blank.png"
          lazy-src="@/assets/img/avatar_blank.png"
          aspect-ratio="1"
          class="item-thumb"
        ></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{ user_data.name }}</v-list-item-title>
        <v-list-item-subtitle>{{ user_data.function }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
</template>

<script>
import appdata from '@/mixins/appdata'

export default {
  mixins: [ appdata ],
  computed: {
    thumb () {
      let value = this.user_data.avatar
      return (value !== null && value !== '' || typeof value !== 'undefined' ? `${this.app_data.upload_dir}${value}` : '')
    }
  }
}
</script>

<style>

</style>
